/**
 * Application Entry Point
 *
 * Renders the React application to the DOM.
 * Initializes error monitoring before React renders.
 *
 * @module main
 */

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

// Initialize Sentry BEFORE React renders to catch early errors
import { initSentry } from '@/lib/sentry';
initSentry();

import App from './App';
import './index.css';

// Get the root element
const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element not found');
}

// Create and render the app
createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>
);
